import React from 'react';
import { useSelector } from 'react-redux';
import parse from 'html-react-parser';
import cN from 'classnames';
import { Tabs } from '@lion-design/core';
import { RootState } from '@Redux/detail/store';
import { I_NoteList } from '@Redux/detail/Itineraries/interfaces';
import styles from './style.module.scss';

const ItineryTravelInfoPC = () => {
    const { NoteList } = useSelector((store: RootState) => store.itinerariesReducer);
    return (
        <div className={cN(styles['itinerary_travelInfo_PC'])}>
            <Tabs defaultActiveKey="預設選中">
                {NoteList.map((item: I_NoteList) => {
                    return (
                        <Tabs.Tab label={item.CTitle} activekey={item.CTitle} key={item.CTitle}>
                            <div dangerouslySetInnerHTML={{ __html: item.Desc }} />
                        </Tabs.Tab>
                    );
                })}
            </Tabs>
        </div>
    );
};

export default ItineryTravelInfoPC;
